<template>
  <div class="active-appointments-index">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${this.serviceSlug}`)},
        { title: this.$t('clinical.appointments.active_appointments'), disabled: true }
      ]">

    </Breadcrumbs>

    <ActiveAppointmentsTable
    :service-slug="this.serviceSlug"/>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs'
import ActiveAppointmentsTable from "@/components/clinical/active-appointments/ActiveAppointmentsTable";
import {mapState} from "vuex";
export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    }
  },
  components: {
    ActiveAppointmentsTable,
    Breadcrumbs
  },
}
</script>

<style lang="scss">

</style>
